import React from "react";
import { Mail, Phone } from "lucide-react";

const Impressum = () => {
  return (
    <div data-testid="impressum-page">
      <section className="bg-[#0a2540] text-white py-16 md:py-20">
        <div className="max-w-[820px] mx-auto px-5 md:px-8">
          <span className="inline-flex items-center gap-2 text-sm font-700 uppercase tracking-widest text-[#5eb0f5]">
            Rechtliches
          </span>
          <h1 className="font-display font-800 text-4xl md:text-5xl mt-3 leading-[1.05]">Impressum</h1>
          <p className="mt-4 text-slate-300 text-lg">Angaben gemäß § 5 DDG</p>
        </div>
      </section>

      <section className="max-w-[820px] mx-auto px-5 md:px-8 py-14">
        <div className="space-y-10 text-[#0a2540]">
          <div data-testid="impressum-provider">
            <p className="font-700 text-lg">BPC, Inhaberin Elisabetta Fierro</p>
            <p className="mt-2 text-slate-600 leading-relaxed">
              Lessingstraße 6<br />
              42327 Wuppertal
            </p>
          </div>

          <div>
            <h2 className="text-sm font-700 uppercase tracking-wider text-slate-400 mb-3">Kontakt</h2>
            <ul className="space-y-2 text-slate-700">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#0a6ed1]" />
                <a href="tel:+491749731988" className="hover:text-[#0a6ed1] transition-colors" data-testid="impressum-phone">
                  +49 1749731988
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#0a6ed1]" />
                <a href="mailto:info@b-p-c.net" className="hover:text-[#0a6ed1] transition-colors" data-testid="impressum-email">
                  info@b-p-c.net
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-700 uppercase tracking-wider text-slate-400 mb-3">Umsatzsteuer-ID</h2>
            <p className="text-slate-700 leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
              <br />
              <span className="font-600">DE464214746</span>
            </p>
          </div>

          <div>
            <h2 className="text-sm font-700 uppercase tracking-wider text-slate-400 mb-3">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p className="text-slate-700 leading-relaxed">
              Elisabetta Fierro<br />
              Lessingstraße 6<br />
              42327 Wuppertal
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
